import CMS from './cms';

export default CMS;
